import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';
import { InputRestrictionDirective } from '../common/directives/input-restriction.directive';
import { InputRestrictionExtendedDirective } from '../common/directives/input-restriction-extended.directive';



@NgModule({
  declarations: [InputRestrictionDirective, InputRestrictionExtendedDirective],
  imports: [
    CommonModule
  ],
  exports:[
    InputRestrictionDirective, InputRestrictionExtendedDirective
  ]
})
export class ShareInputRestrictionModule { }
